
export default {
  name: "CryptoPrices",
  components: {},
  mixins: [],
  props: [],
  async asyncData({store}) {
    // const isLogin = store.getters['auth/getAuthStatus'];
    // const isLogin = false;
    // const baseSymbolsData= [];

    // let favoritesData;
    const symbolsData = await store.dispatch("markets/fetchMarketsPricesList");
    
    // let baseSymbolsData = await store.dispatch("markets/fetchAllBaseCoin")

    let dynamicBaseSymbolsData = await store.dispatch("markets/fetchAllDynamicBaseCoin")

    dynamicBaseSymbolsData = dynamicBaseSymbolsData.data
    // if (isLogin) {
    //   favoritesData = await store.dispatch("markets/fetchFavoredMarkets")
    //   .then(response => {
    //     if(!response.data.code && response.data.code !== 401 ) {
    //       baseSymbolsData.push("Favorites")
    //       return response
    //     }
    //   });
    // }
    // if(symbolsData.length > 0) {
    //   symbolsData.forEach(item => {
    //     if (!baseSymbolsData.includes(item.symbol.split("/")[1])) {
    //       baseSymbolsData.push(item.symbol.split("/")[1]);
    //     }
    //     // if (isLogin && favoritesData && !favoritesData.data.code) {
    //     //   item.favored = favoritesData.data.map(elem => elem.symbol).includes(item.symbol);
    //     // }
    //   });
    // }
    return {
      symbolsData,
      dynamicBaseSymbolsData
    };
  },
  data() {
    return {};
  },
  head() {
    return {
      title: 'Enifex : Markets',
    }
  },
  computed: {},
  mounted() {
  },
  methods: {},
};
